import { render } from "./overlay.vue?vue&type=template&id=0bf82982&scoped=true"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import "./overlay.vue?vue&type=style&index=0&id=0bf82982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf82982"]])

export default __exports__